import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import Autocomplete from '@mui/material/Autocomplete';
import { UseStores } from '../../../hooks/UseStores';

function marketToText(market) {
  return market ? `${market.market}, ${market.state}` : '';
}

const MarketSelect = ({ onChange }) => {
  const { audience } = UseStores();
  const [selected, setSelected] = useState('');

  const onChangeDropdown = useCallback(
    (event, value) => {
      if (value === null) {
        onChange('');
        setSelected('');
      } else {
        onChange(value.prodcode);
        setSelected(value);
      }
    },
    [onChange],
  );

  const handleClear = () => {
    setSelected(audience.markets[0] ?? '');
  };

  const defaultProps = {
    options: audience.markets,
    getOptionLabel: (option) => marketToText(option),
  };

  useEffect(() => {
    handleClear();
  }, [audience.selectedAudience.label]);

  return (
    <Autocomplete
      {...defaultProps}
      id="abdm-markets"
      value={selected}
      onChange={onChangeDropdown}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="Enter a City Name"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <PlaceOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};

export default observer(MarketSelect);
